// extracted by mini-css-extract-plugin
export default {"grabbable":"styles_grabbable__WLQ2p"};